<template lang="pug">
section#customer.container.i_ptb_8(:class="{partner:shouldShowPartnerCol}")
  .row
    .col-md-auto.text-center.text-md-left
      .img(v-if="image", :style="{ backgroundImage: 'url(' + image + ')' }")
    .col.d-flex.flex-column.i_ptb_10.i_ptb_md_6
      h2.text-center {{ title }}
      .amounts.d-flex.justify-content-around.justify-content-md-between.justify-content-lg-around
        p.text-left.text-md-right
          span.d-block.d-md-inline {{ locationNumber }}
          span.d-inline 個
          span.d-inline.d-md-block 綿密服務據點
        p.text-left.text-md-right
          span.d-block.d-md-inline 24
          span.d-inline 小時
          span.d-md-block.d-md-block 全天候服務
        p.text-left.text-md-right
          span.d-block.d-md-inline 365
          span.d-inline 天
          span.d-md-block.d-md-block 全年服務不中斷
    //- .col(v-if="$route.name == 'Home'")
    .col(v-if="shouldShowPartnerCol")
      .ad
        h6.text-center 合作夥伴
        .slider_content.d-flex.flex-column.justify-content-around
          swiper.swiper-container(:options="swiperOption", ref="mySwiper")
            swiper-slide.swiper-slide(
              v-for="(sliderContent, index) in filteredPartnerItems",
              :key="index"
            )
              .head_wrapper.i_plr_sm_12.i_ptb_sm_6
                .banner
                  .i_h4.d-block.d-md-none.i_pr_4 {{ sliderContent.Title }}
                  .img(
                    :style="{ backgroundImage: 'url(' + sliderContent.Image + ')' }"
                  )
                .content
                  .i_h4.d-none.d-md-block.text-center {{ sliderContent.Title }}
                  p.i_body_l.i_mt_sm_4(v-html="sliderContent.Content")
                  a(:href="sliderContent.Url", target="_blank")
                    .see_more_btn.sm.btn_blue_ci.text-center 了解更多
          svg-icon.swiper-prev.d-md-none(
            iconClass="arrow_left_mobile",
            className="icon",
            @click="prevClick"
            v-if="filteredPartnerItems && filteredPartnerItems.length > 1"
          )
          svg-icon.swiper-next.d-md-none(
            iconClass="arrow_right_mobile",
            className="icon",
            @click="nextClick"
            v-if="filteredPartnerItems && filteredPartnerItems.length > 1"
          )
        div(style="width: 100%")
          .swiper-pagination-customer.d-none.d-md-block(slot="pagination")
</template>

<script>
export default {
  name: "Home",
  props: {
    image: String,
    title: String,
    locationNumber: String,
    area03_PartnerItems: Array,
  },
  data() {
    var self = this;
    return {
      swiperOption: {
        notNextTick: true,
        initialSlide: 0,
        slidesPerView: 1,
        spaceBetween: 20,
        loop: false,
        direction: "horizontal",
        grabCursor: false,
        setWrapperSize: true,
        autoHeight: false,
        mousewheelControl: true,
        observeParents: true,
        debugger: true,
        paginationClickable: true,
        pagination: {
          el: ".swiper-pagination-customer",
          clickable: true,
        },
        on: {
          slideChangeTransitionStart: function () {
            self.bannerIndex = this.realIndex;
          },
        },
      },
      bannerIndex: 0,
    };
  },
  computed: {
    sliderBannerSwiper() {
      return this.$refs.mySwiper.$swiper;
    },
    filteredPartnerItems() {
      // 使用過濾函數篩選 area03_PartnerItems，只保留具有非空 image、title 和 url 的項目
      return this.area03_PartnerItems?.filter(({ Image, Title, Url }) => Image && Title && Url);
    },
    shouldShowPartnerCol() {
      return this.$route.name === 'Home' && this.filteredPartnerItems && this.filteredPartnerItems.length >= 1;
    }

  },
  methods: {
    prevClick() {
      this.sliderBannerSwiper.slidePrev();
    },
    nextClick() {
      this.sliderBannerSwiper.slideNext();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/home/customer";
@import "@/assets/style/home/partner";
.customer_green h2{
  color: #008578!important;
}
.customer_green .amounts p span:first-child{
  color:#00a69c!important;
}
</style>  